<template>
  <b-container fluid>
    <h1>All Unviewed Orders</h1>
    <b-row>
      <b-col>
        <b-button
          variant="warning"
          @click="viewSelected"
        >
          Mark {{ selectedList.length }} Selected Order{{ selectedList.length === 1 ? '' : 's'}} as Viewed
        </b-button>
      </b-col>
      <b-col>
        <b-pagination
          align="right"
          :total-rows="unviewedOrdersCount"
          :per-page="perPage"
          v-model="currentPage"
          @input="onPaginate"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-table
        striped
        hover
        class="wide-table"
        :items="unviewedOrders"
        :fields="columns"
        sort-by.sync="DateCreated"
        :sort-desc="false"
      >
        <template slot="selected" slot-scope="data">
          <b-form-checkbox v-model="data.item.selected"/>
        </template>
        <template slot="num" slot-scope="data">
          <router-link
            :to="{ name: 'View Order', params: { id: data.item.num }}"
            target="_blank"
          >{{ data.item.num }}</router-link>
        </template>
        <template slot="totalPrice" slot-scope="data">
          {{ data.item.totalPrice / 100 | formatDollars }}
        </template>
        <template slot="dateCreated" slot-scope="data">
          <NiceDate :value="data.item.dateCreated" />
        </template>
        <template slot="paymentMethod" slot-scope="data">
          {{ data.item.paymentMethod.join(', ') }}
          <b-btn v-if="data.item.poUrl" variant="primary-outline" target="_blank" :href="data.item.poUrl">View PO</b-btn>
        </template>
      </b-table>
    </b-row>

    <b-modal
      id="statusModal"
      v-model="loading"
      centered
      :hide-header-close="true"
      show v-if="loading"
    >
      <center>
        {{ this.loadingMessage }}
        <fingerprint-spinner
          :animation-duration="1500"
          :size="300"
          color="#293a93"
          class="my-3"
        />
        <br />

        <b-btn @click='scrubOrders' variant=warning size=sm>Is this page taking a long time to load?<br/>Push this to perform some IT magic!</b-btn>
      </center>
      <div slot="modal-footer" class="w-100" />
    </b-modal>

  </b-container>
</template>

<script>
import axios from 'axios';
import NiceDate from '../utility/NiceDate';
import { FingerprintSpinner } from 'epic-spinners';
import BridgeService from '../../services/bridge';

const BASE_API = process.env.VUE_API_ROOT;

export default {
  components: {
    NiceDate,
    FingerprintSpinner,
  },
  data() {
    return {
      perPage: 100,
      currentPage: 1,
      columns: [{
          key: 'selected',
          sortable: true,
        }, {
          key: 'dateCreated',
          sortable: true,
        }, {
          key: 'num',
          label: 'Order Num',
          sortable: true,
        }, {
          key: 'paymentMethod',
          sortable: true,
        }, {
          key: 'totalPrice',
          sortable: true,
        }, {
          key: 'carrier',
          sortable: true,
        }, {
          key: 'orderNotes',
          sortable: true,
        },
      ],
      modalData: {
        fishbowl: {},
      },
      loading: true,
      loadingMessage: '',
      unviewedOrdersCount: 0,
      unviewedOrders: [],
    };
  },
  mounted() {
    this.loadingMessage = 'Fetching Orders. Please Wait';
    this.getUnviewedOrders();
  },
  computed: {
    selectedList() {
      return this.unviewedOrders.filter(x => x.selected);
    },
  },
  methods: {
    getUnviewedOrders(){
      this.loading = true
      axios.get(`${BASE_API}/fishbowl/order/unviewed/${this.currentPage}`).then(response => {
        this.unviewedOrdersCount = response.data.totalCount
        this.unviewedOrders = response.data.page.map(order => ({
          dateCreated: order.dateCreated,
          num: order.num,
          paymentMethod: order.paymentMethod,
          totalPrice: order.totalPrice * 100,
          carrier: order.carrier,
          orderNotes: order.orderNotes,
          poUrl: order.poFile,
        }))
      }).catch((error) => {
        console.error(error);
        return [];
      }).finally(() => this.loading = false );
    },
    scrubOrders() {
      axios({
        method: 'post',
        headers: { 'Content-Type': 'text/plain' },
        url: `${BASE_API}/fishbowl/order/unviewed/clean`,
      }).then((response) => {
        this.getUnviewedOrders();
      })
    },
    onPaginate(page) {
      this.getUnviewedOrders(page);
    },
    viewSelected() {
      let orders = this.selectedList.map(x => x.orderNum);
      if (orders.length === 0) return;

      axios({
        method: 'post',
        headers: { 'Content-Type': 'text/plain' },
        url: `${BASE_API}/fishbowl/order/unviewed/`,
        data: orders,
      }).then((response) => {
        this.getUnviewedOrders(this.currentPage);
      }).catch((error) => {
        console.error(error);
        return [];
      });
    },
  },
  watch: {
    loadingUnviewedOrders() {
      this.loading = this.loadingUnviewedOrders;
    },
  },
};
</script>

<style scoped>
  .wide-table {
    margin-top: 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/sales-order/AllOrders.vue